import { useContext, useEffect, useLayoutEffect } from 'react';
import { isServer } from '@okapi/dom-utils';
import { off, on } from '@okapi/pubsub';
import { RouterContext } from './Provider';
const useIsomorphicLayoutEffect = isServer() ? useEffect : useLayoutEffect;
/**
 * Добавляет подписку на смену текущего пути
 */
export function useSubscription(callback) {
    const router = useContext(RouterContext);
    useIsomorphicLayoutEffect(() => {
        on('changePath', callback);
        return () => {
            off('changePath', callback);
        };
    }, [router, callback]);
}
